import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import AddressPicker from "../components/AddressPicker";
import { LocationContext } from "../context/LocationContext";
import { useContext } from "react";
import MapPicker from "../components/MapPicker";
import Cropper from "react-easy-crop";
import Swal from "sweetalert2";

function UploadPrescription() {
  /* ===================== STATES ===================== */
const { lat, lng, address: liveAddress } = useContext(LocationContext);
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
const [medicineDays, setMedicineDays] = useState("");
const [useManualAddress, setUseManualAddress] = useState(false);
  const [orderType, setOrderType] = useState(""); // us | hospital
  const [hospitals, setHospitals] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState("");
const token = localStorage.getItem("accessToken");
const navigate = useNavigate();

const [showMap, setShowMap] = useState(false);
const [tempAddress, setTempAddress] = useState("");
const [tempLat, setTempLat] = useState(null);
const [tempLng, setTempLng] = useState(null);


const [cropImage, setCropImage] = useState(null);
const [showCrop, setShowCrop] = useState(false);		
const [crop, setCrop] = useState({ x: 0, y: 0 });
const [zoom, setZoom] = useState(1.5);
const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);


const [manualAddress, setManualAddress] = useState("");

const [manualLat, setManualLat] = useState(null);

const [manualLng, setManualLng] = useState(null);

  const [rxId, setRxId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  /* ===================== LOAD HOSPITALS ===================== */
  useEffect(() => {
    if (orderType === "hospital") {
      axios
        .get("/hospitals/")
        .then((res) => setHospitals(res.data || []))
        .catch(() => {});
    }
  }, [orderType]);


useEffect(() => {
  setSubmitted(false);
  setLoading(false);
}, []);




useEffect(() => {
  setOrderType("hospital");
}, []);





  /* ===================== FILE HANDLER (REPLACE MODE) ===================== */
const handleFiles = (e) => {
  const selected = Array.from(e.target.files);
  if (!selected.length) return;

  const updatedFiles = [...files, ...selected];
  setFiles(updatedFiles);

  const urls = updatedFiles.map((f) => ({
    url: URL.createObjectURL(f),
    type: f.type,
  }));

  setPreviews(urls);
};




useEffect(() => {
  return () => {
    previews.forEach((p) => URL.revokeObjectURL(p.url));
  };
}, [previews]);



const onCropComplete = (_, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels);
};


const getCroppedImg = async () => {
  const image = new Image();
  image.src = cropImage;

  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const { width, height, x, y } = croppedAreaPixels;

  canvas.width = width;
  canvas.height = height;

  ctx.drawImage(
    image,
    x,
    y,
    width,
    height,
    0,
    0,
    width,
    height
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      const file = new File([blob], "cropped.jpg", {
        type: "image/jpeg",
      });
      resolve(file);
    }, "image/jpeg");
  });
};



const handleCropConfirm = async () => {
  const croppedFile = await getCroppedImg();

  const updatedFiles = [...files, croppedFile];
  setFiles(updatedFiles);

  const urls = updatedFiles.map((f) => ({
    url: URL.createObjectURL(f),
    type: f.type,
  }));

  setPreviews(urls);

  setShowCrop(false);
};


  /* ===================== RE-UPLOAD ===================== */
  const reUploadAll = () => {
    setFiles([]);
    setPreviews([]);
    setSubmitted(false);
    setRxId(null);
    document.getElementById("mainUpload").click();
  };

  /* ===================== SUBMIT RX ===================== */
  const submitPrescription = async () => {
  if (loading) return;

 if (!files.length) {
  Swal.fire({
    icon: "warning",
    title: "No Prescription",
    text: "Please upload your prescription"
  });
  return;
}
 if (!orderType) {
  Swal.fire({
    icon: "warning",
    title: "Select Order Type",
    text: "Please choose how you want to order"
  });
  return;
}
if (orderType === "hospital" && !selectedHospital) {
  Swal.fire({
    icon: "warning",
    title: "Select Hospital",
    text: "Please choose a hospital"
  });
  return;
}

  setLoading(true);

const form = new FormData();

// 🔹 multiple prescription files
files.forEach((f) => form.append("files", f));

// 🔹 order info
form.append("order_type", orderType);

if (orderType === "hospital") {
  form.append("hospital_id", selectedHospital);
}

// 🔥 NEW: medicine days (user requirement)
form.append("medicine_days", medicineDays);

form.append(
  "delivery_address",
  useManualAddress ? manualAddress : liveAddress
);

form.append(
  "customer_lat",
  useManualAddress ? manualLat : lat
);

form.append(
  "customer_lng",
  useManualAddress ? manualLng : lng
);




try {
  const res = await axios.post(
  "/prescriptions/upload/",
  form,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);
  setRxId(res.data.id);
  setSubmitted(true);

  setTimeout(() => {
    navigate("/prescriptions"); // history page
  }, 3000);

} catch (err) {
  console.error(err);
  Swal.fire({
    icon: "error",
    title: "Upload Failed",
    text: "Something went wrong. Please try again",
    confirmButtonColor: "#dc2626"
  });
}


   finally {
    setLoading(false);
  }
};


return (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 20,
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: 460,
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        padding: 24,
      }}
    >
      {/* HEADER */}
      <h2 style={{ textAlign: "center", marginBottom: 6 }}>
        💊 Upload Prescription
      </h2>
      <p style={{ textAlign: "center", color: "#666", fontSize: 14 }}>
        Upload your doctor’s prescription and get medicine at home
      </p>

      {/* UPLOAD */}
      <div
        style={{
          marginTop: 20,
          border: "2px dashed #90caf9",
          borderRadius: 12,
          padding: 16,
          textAlign: "center",
          background: "#f8fbff",
        }}
      >


{!files.length && (
  <div style={{ display: "flex", gap: 10, marginTop: 10 }}>



    {/* 📂 GALLERY / FILE */}
    <label
      style={{
        flex: 1,
        padding: 10,
        background: "#1976d2",
        color: "#fff",
        borderRadius: 8,
        textAlign: "center",
        cursor: "pointer"
      }}
    >
      📂 Upload File
      <input
        type="file"
        accept="image/*,.pdf"
        hidden
        onChange={handleFiles}
      />
    </label>

  </div>
)}

        {previews.map((p, i) => (
          <div key={i} style={{ marginTop: 12 }}>
            {p.type === "application/pdf" ? (
              <iframe
                src={p.url}
                width="100%"
                height="180"
                title="pdf"
                style={{ borderRadius: 8 }}
              />
            ) : (
              <img
                src={p.url}
                alt="rx"
                style={{
                  width: "100%",
                  borderRadius: 10,
                  border: "1px solid #eee",
                }}
              />
            )}
          </div>
        ))}

        {files.length > 0 && (
          <button
            onClick={reUploadAll}
            style={{
              marginTop: 10,
              background: "none",
              border: "none",
              color: "#e53935",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            🔁 Re-upload
          </button>
        )}

        <button
          disabled={!files.length}
          onClick={() => document.getElementById("extraUpload").click()}
          style={{
            marginTop: 6,
            background: "none",
            border: "none",
            color: files.length ? "#1976d2" : "#aaa",
            fontSize: 13,
            cursor: files.length ? "pointer" : "not-allowed",
          }}
        >
          ➕ Add more images
        </button>

        <input
          id="extraUpload"
          type="file"
          multiple
          hidden
          accept="image/*,.pdf"
          onChange={handleFiles}
        />
      </div>



      {/* HOSPITAL LIST */}
{orderType === "hospital" && (
  <div style={{ marginTop: 14 }}>
    <h4>🏥 Select Hospital</h4>

    <select
      value={selectedHospital}
      onChange={(e) => setSelectedHospital(e.target.value)}
      style={{
        width: "100%",
        padding: 10,
        marginTop: 6,
        borderRadius: 8,
        border: "1px solid #ccc",
        fontSize: 14,
        background: "#fff",
      }}
    >
      <option value="">-- Choose Hospital --</option>

      {hospitals.map((h) => (
        <option key={h.id} value={h.id}>
          {h.name}
        </option>
      ))}
    </select>
  </div>
)}


      {/* MEDICINE DAYS */}
      <div style={{ marginTop: 16 }}>
        <h4>📅 Medicine Duration</h4>

        <input
          type="number"
          placeholder="Enter days (eg. 7)"
          value={medicineDays}
          onChange={(e) => setMedicineDays(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            marginTop: 6,
            borderRadius: 8,
            border: "1px solid #ccc",
            fontSize: 14,
          }}
        />
      </div>






<h3>Address</h3>

{/* CURRENT LOCATION */}

<label style={{ display: "flex", gap: 8, marginBottom: 5 }}>
  <input
    type="radio"
    checked={!useManualAddress}
    onChange={() => setUseManualAddress(false)}
  />
  Use Current Location
</label>

<input
  type="text"
  value={liveAddress || ""}
  readOnly
  placeholder="Fetching current location..."
  style={{
    ...input,
    background: useManualAddress ? "#f3f4f6" : "white"
  }}
/>
{/* MANUAL ADDRESS */}

<label style={{ display: "flex", gap: 8, marginTop: 15, marginBottom: 5 }}>
  <input
    type="radio"
    checked={useManualAddress}
    onChange={() => setUseManualAddress(true)}
  />
  Enter Address Manually
</label>
<div style={{
  background: "#fff3cd",
  padding: "10px",
  borderRadius: "6px",
  marginBottom: "10px",
  fontSize: "13px",
  color: "#92400e"
}}>
  📍 <strong>Important:</strong> Please select your address from the Google suggestions dropdown.
  After selecting, confirm your exact location on the map and press <strong>"Confirm Location"</strong>.
  Orders may fail if the address is entered manually without selection.
</div>


{/* MANUAL ADDRESS */}




{/* GOOGLE AUTOCOMPLETE INPUT */}

<AddressPicker

 value={manualAddress}

 disabled={!useManualAddress}

 onChange={(addr) => {

   setManualAddress(addr);

 }}

 onSelect={(data) => {

   setManualAddress(data.address);

   setManualLat(data.lat);

   setManualLng(data.lng);


   // auto open map
   setTempAddress(data.address);

   setTempLat(data.lat);

   setTempLng(data.lng);

   setShowMap(true);

 }}

/>
<button

disabled={!useManualAddress}

onClick={() => {

 if (!useManualAddress) return;

 setTempAddress(manualAddress);

 setTempLat(manualLat || lat);

 setTempLng(manualLng || lng);

 setShowMap(true);

}}

style={{
 padding:10,
 background: useManualAddress ? "#2563eb" : "#9ca3af",
 color:"#fff",
 border:"none",
 borderRadius:6,
 marginBottom:10,
 cursor: useManualAddress ? "pointer" : "not-allowed"
}}

>

📍 Select on Map

</button>
{showMap && (

<div>

<MapPicker

 lat={tempLat}

 lng={tempLng}

 onSelect={(data)=>{

   setTempAddress(data.address);

   setTempLat(data.lat);

   setTempLng(data.lng);

 }}

/>


<button

onClick={()=>{

 setManualAddress(tempAddress);

 setManualLat(tempLat);

 setManualLng(tempLng);

 setShowMap(false);

}}

style={{
 width:"100%",
 padding:12,
 background:"green",
 color:"#fff",
 border:"none",
 borderRadius:6
}}

>

Confirm Location

</button>

</div>

)}






      {/* SUBMIT */}
      <button
        onClick={submitPrescription}
        disabled={loading || submitted}
        style={{
          width: "100%",
          marginTop: 24,
          padding: 12,
          borderRadius: 12,
          background: loading
            ? "#90caf9"
            : "linear-gradient(135deg,#1976d2,#42a5f5)",
          color: "#fff",
          border: "none",
          fontSize: 16,
          fontWeight: "bold",
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "⏳ Uploading..." : "Submit Prescription"}
      </button>

      {/* SUCCESS MESSAGE */}
      {submitted && rxId && (
        <div
          style={{
            marginTop: 20,
            padding: 16,
            borderRadius: 12,
            background: "#e8f5e9",
            color: "#2e7d32",
            fontSize: 14,
            textAlign: "center",
          }}
        >
          <strong>✅ Prescription Submitted</strong>
          <br />
          <br />

          {orderType === "hospital" ? (
            <>Hospital pharmacist is preparing your bill.</>
          ) : (
            <>Our pharmacist is preparing your bill.</>
          )}

          <br />
          ⏱ Usually takes 5–10 minutes
          <br />
          📲 You will get notification soon
        </div>
      )}







    </div>
  </div>
);

}
const input = {
  width: "100%",
  padding: 10,
  marginBottom: 10
};
export default UploadPrescription;
